import { use, useMemo, useRef } from 'react';
import { type ListDropdownItem } from '@sr/types';
import { Dropdown, SimpleSelectList } from '../Dropdown';
import { withSegmentedButtonsProvider } from './hooks/withSegmentedButtonsProvider';
import {
  DesktopStyle,
  MobileStyle,
  SegmentedButtonsWrapper,
  StyledSegmentedButtons,
  Wrapper,
} from './styles';
import { SegmentedButtonsContexts } from './context/SegmentedButtonsContext';
import { SegmentButton } from './components';

export * from './components';

/**
 * @deprecated This component will be removed in future releases.
 * Please use the new SegmentedButtonsV2 component instead.
 */
export const SegmentedButtons = withSegmentedButtonsProvider(() => {
  const parentRef = useRef<HTMLDivElement>(null);
  const { setSelectedValue, selectedValue } = use(SegmentedButtonsContexts.useCurrentIndex);

  const { items } = use(SegmentedButtonsContexts.props);

  const handleOnChange = (value: string[]) => {
    setSelectedValue(value[0]);
  };

  const dropDownItems = useMemo((): ListDropdownItem[] => {
    return items.map((item) => {
      return {
        label: item.label,
        value: item.value,
        type: 'value',
        children: [],
      };
    });
  }, [items]);

  return (
    <Wrapper>
      <DesktopStyle>
        <SegmentedButtonsWrapper>
          <StyledSegmentedButtons ref={parentRef}>
            {items.map((item) => (
              <SegmentButton
                key={item.value}
                value={item.value}
                label={item.label}
                testId={`segmentedButton-${item.value}`}
              />
            ))}
          </StyledSegmentedButtons>
        </SegmentedButtonsWrapper>
      </DesktopStyle>
      <MobileStyle>
        <Dropdown
          items={dropDownItems}
          onChange={(value) => {
            handleOnChange(value);
          }}
          multiSelect={false}
          label=""
          selectedValues={selectedValue ? [selectedValue] : []}
          placeholder="Select a value"
        >
          <SimpleSelectList />
        </Dropdown>
      </MobileStyle>
    </Wrapper>
  );
});
